module.exports = __webpack_public_path__ + "img/iron.6a543e90.webp";